import React, { useRef, useState } from "react";
import { Button, Divider, Flex } from "antd";
import EducationList from "components/CandidateCard/EducationDetails";
import CandidateAddEducationForm from "./CandidateAddEducationForm";
import TooltipWrapper from "./TooltipWrapper";

export interface EducationExperience {
  schoolName: string;
  degree: string;
  field: string;
  start_date_formatted: string;
  end_date_formatted: string;
  description?: string | null;
  logo_url?: string | null;
  edited_by?: string | null;
  modified_date?: string | null;
  is_edited?: boolean;
}

interface AllEducationProps {
  education?: EducationExperience[]; // Expecting an array of education experiences
  clickedProfile?: number;
  isEditedEducations?: boolean;
  editorName?: string;
  setRefresh?: React.Dispatch<React.SetStateAction<boolean>>;
  loading?: boolean;
  setError?: React.Dispatch<React.SetStateAction<string | null>>;
  tooltipText?: string;
}

const AllEducation: React.FC<AllEducationProps> = ({ education, clickedProfile, isEditedEducations, editorName, setRefresh, loading, setError, tooltipText }) => {
  const [isAddEducation, setIsAddEducation] = useState<boolean>(false);
  const formRef = useRef<HTMLDivElement>(null);

  const education_experience = education
    ? education.map((edu) => ({
      degree: edu.degree,
      field: edu.field,
      schoolName: edu.schoolName,
      start_date_formatted: edu.start_date_formatted,
      edited_by: edu.edited_by ?? "",
      modified_date: edu.modified_date ?? "",
      is_edited: edu.is_edited ?? false,
    }))
    : [];

  const handleAddEducations = () => {
    setIsAddEducation(true);
    setTimeout(() => {
      formRef.current?.scrollIntoView({ behavior: "smooth" });
    }, 100);
  };

  return (
    <div>
      <Flex justify="space-between" align="center" className="p-[6px]">
        <div className="text-text-heading font-bold pr-2.5 text-base text-sm">Education:</div>
        {/* {tooltipText ? (
          // <TooltipWrapper text={tooltipText} placement="right">
            <div className="text-text-heading font-bold pr-2.5 text-base text-sm">Education:</div>
          </TooltipWrapper>
        ): (
          <div className="text-text-heading font-bold pr-2.5 text-base text-sm">Education:</div>
        )} */}
      </Flex>
      <Divider style={{ margin: "0 0 16px 0" }} />
      <div className="mt-5">
        <EducationList education_experience={education_experience} showAll={true} />
      </div>
      {isEditedEducations && !isAddEducation && (
        <Button type="dashed" onClick={handleAddEducations} className="text-xs font-semibold text-text-primary my-4">
          + Add Education
        </Button>
      )}
      {isEditedEducations && isAddEducation && (
        <div ref={formRef} className="w-full mt-2">
          <CandidateAddEducationForm setIsAddEducation={setIsAddEducation} editorName={editorName!} candidateId={clickedProfile!} setRefresh={setRefresh!} loading={loading!} setError={setError!} />
        </div>
      )}
    </div>
  );
};

export default AllEducation;
